import { Get } from './helpers';

export const GetPeople = async (token: string, channel: number, offset: number, sortBy: number): Promise<any> => {
	return Get(`/v3/admin/events/registrations/${channel}/${offset}/${sortBy}`, token, {}, true)
		.then(async res => {
			if (res.ok) {
				return await res.json();
			}

			return { error: res.status };
		});
};

export const GetPeopleCount = async (token: string, channel: number): Promise<any> => {
	return Get(`/v3/admin/events/count-registrations/count/${channel}`, token);
};

export function GetPeopleSearchCount(
	token: string,
	channel: number,
	value: string
): Promise<any> {
	if (value === '') {
		return Get(
			`/v3/admin/events/count-registrations/count/${channel}`,
			token
		);
	}
	else {
		return Get(
			`/v3/admin/events/count-registrations/count/${channel}/${value}`,
			token
		);
	}
}

export function SearchPeople(
	token: string,
	channel: number,
	value: string,
	offset: number,
	order: number
): Promise<any> {
	if (value === '') {
		return Get(
			`/v3/admin/events/registrations/${channel}/${offset}/${order}`,
			token
		);
	} else {
		return Get(
			`/v3/admin/events/registrations/${channel}/${offset}/${order}/${value}`,
			token
		);
	}
}


export function GetEventRegistrations(
	token: string,
	channel: number,
	event: number,
	offset: number,
	order: number
): Promise<any> {
	return Get(
		`/v3/admin/events/event-registrations/${channel}/${event}/${offset}/${order}`,
		token
	);
}

export function GetEventRegistrationsCount(
	token: string,
	channel: number,
	value: string,
	event: number
): Promise<any> {
	if (value === '') {
		return Get(
			`/v3/admin/events/count-event-registrations/count/${channel}/${event}`,
			token
		);
	}
	else {
		return Get(
			`/v3/admin/events/count-event-registrations/count/${channel}/${event}/${value}`,
			token
		);
	}
}

export function SearchEventRegistrations(
	token: string,
	channel: number,
	value: string,
	offset: number,
	order: number,
	event: number
): Promise<any> {
	if (value === '') {
		return Get(
			`/v3/admin/events/event-registrations/${channel}/${event}/${offset}/${order}`,
			token
		);
	} else {
		return Get(
			`/v3/admin/events/event-registrations/${channel}/${event}/${offset}/${order}/${value}`,
			token
		);
	}
}

